import React, { useEffect, useRef, useState } from "react";
import SearchBox from "../../components/common/SearchBox";
import uploadIcon from '../../assets/images/upload_icon.svg';
import breadcrumbArrow from '../../assets/images/breadcrumb_arrow.svg';
import folderIcon from '../../assets/images/folder_icon.svg';
import moreIcon from '../../assets/images/more_icon.svg';
import plusIcon from '../../assets/images/plus_icon.svg';

import fileImg from '../../assets/images/file_img.jpg';
import moreVertical from '../../assets/images/more_vertical.svg';
import infoIcon from '../../assets/images/info_icon.svg';
import downloadIcon from '../../assets/images/downloadIcon.svg';

import editIcon from '../../assets/images/edit_icon.svg';
import copyIcon from '../../assets/images/copy_icon.svg';
import downloadBlack from '../../assets/images/download_black.svg';
import deleteIcon from '../../assets/images/delete_icon.svg';

const Dashboard = () => {
  const [query, setQuery] = useState("");
  const [openCreativeUpload, setOpenCreativeUpload] = useState(false);
  const [activeTab, setActiveTab] = useState("march");
  const [showDropdown, setShowDropdown] = useState(false);
  const [showBox, setShowBox] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (boxRef.current && !boxRef.current.contains(event.target)) {
        setShowBox(false);
      }
    };

    // Attach listener on mount
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup on unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="flex flex-col gap-5 max-h-[95vh] overflow-scroll scroll-smooth pb-10">
        <h2 class="pageHeading mb-0">creative approval</h2>
        <div className="bradcrumb_row">
          <a href="#">Homepage</a>
          <img
            alt=""
            height="8px"
            width="5px"
            src={breadcrumbArrow}
          />
          <span>Triumph</span>
        </div>
        <div className="flex gap-3 justify-between items-center w-full">
          <SearchBox query={query} setQuery={setQuery} />
          <button
            className="py-2 px-4 w-[176px] h-[40px] font-medium flex items-center gap-1 justify-center text-white text-nowrap text-sm transition-all duration-700 ease-in-out hover:bg-black bg-[#1890FF] shadow-sm rounded"
            onClick={() => setOpenCreativeUpload(true)}
          >
            <img
              alt=""
              height="14px"
              width="14px"
              src={uploadIcon}
            /> Upload
          </button>
        </div>
        <div className="dashboard_card_wrap">
          <div className="dashboard_card">
            <div className="card_icon">
              <img
                alt=""
                width="40px"
                height="33px"
                src={folderIcon}
              />
            </div>
            <div className="card_text">
              <h6>Giriraj</h6>
              <span>18 Mar 2025</span>
              <button type="button" className="more_btn" onClick={() => setShowBox(true)}>
                <img
                  alt=""
                  width="24px"
                  height="24px"
                  src={moreIcon}
                />
              </button>
            </div>
            {showBox && (
              <div
                ref={boxRef}
                className="filter_dropdown_box"
              >
                <button className="filter_dropdown_btn">
                  <img
                    alt=""
                    width="16px"
                    height="16px"
                    src={editIcon}
                  /> Rename
                </button>
                <button className="filter_dropdown_btn">
                  <img
                    alt=""
                    width="16px"
                    height="16px"
                    src={copyIcon}
                  /> Copy
                </button>
                <button className="filter_dropdown_btn">
                  <img
                    alt=""
                    width="16px"
                    height="16px"
                    src={downloadBlack}
                  /> Download
                </button>
                <button className="filter_dropdown_btn delete_btn">
                  <img
                    alt=""
                    width="16px"
                    height="17px"
                    src={deleteIcon}
                  /> Delete
                </button>
              </div>
            )}
          </div>

          <div className="dashboard_card">
            <div className="card_icon">
              <img
                alt=""
                width="40px"
                height="33px"
                src={folderIcon}
              />
            </div>
            <div className="card_text">
              <h6>QA Testing Folder</h6>
              <span>18 Mar 2025</span>
              <button type="button" className="more_btn">
                <img
                  alt=""
                  width="24px"
                  height="24px"
                  src={moreIcon}
                />
              </button>
            </div>
          </div>
          <div className="dashboard_card">
            <div className="card_icon">
              <img
                alt=""
                width="40px"
                height="33px"
                src={folderIcon}
              />
            </div>
            <div className="card_text">
              <h6>Are you sure you want</h6>
              <span>18 Mar 2025</span>
              <button type="button" className="more_btn">
                <img
                  alt=""
                  width="24px"
                  height="24px"
                  src={moreIcon}
                />
              </button>
            </div>
          </div>
          <div className="dashboard_card">
            <div className="card_icon">
              <img
                alt=""
                width="40px"
                height="33px"
                src={folderIcon}
              />
            </div>
            <div className="card_text">
              <h6>Giriraj</h6>
              <span>18 Mar 2025</span>
              <button type="button" className="more_btn">
                <img
                  alt=""
                  width="24px"
                  height="24px"
                  src={moreIcon}
                />
              </button>
            </div>
          </div>
          <div className="dashboard_card">
            <div className="card_icon">
              <img
                alt=""
                width="40px"
                height="33px"
                src={folderIcon}
              />
            </div>
            <div className="card_text">
              <h6>QA Testing Folder</h6>
              <span>18 Mar 2025</span>
              <button type="button" className="more_btn">
                <img
                  alt=""
                  width="24px"
                  height="24px"
                  src={moreIcon}
                />
              </button>
            </div>
          </div>
          <div className="dashboard_card_add">
            <img
              alt=""
              width="40px"
              height="33px"
              src={plusIcon}
            />
            <span>Add Folder</span>
          </div>
        </div>
        <div className="file_section_wrap">
          <div className="file_section_head">
            <h6>Files</h6>
          </div>
          <div className="file_tab_content">
            <div className="tabs-container">
              <div className="tabs-header">
                <button
                  className={activeTab === "march" ? "active" : ""}
                  onClick={() => setActiveTab("march")}
                >
                  March
                </button>
                <button
                  className={activeTab === "april" ? "active" : ""}
                  onClick={() => setActiveTab("april")}
                >
                  April
                </button>
                <button
                  className={activeTab === "may" ? "active" : ""}
                  onClick={() => setActiveTab("may")}
                >
                  May
                </button>
                <button
                  className={activeTab === "june" ? "active" : ""}
                  onClick={() => setActiveTab("june")}
                >
                  June
                </button>
                <button
                  className={activeTab === "july" ? "active" : ""}
                  onClick={() => setActiveTab("july")}
                >
                  July
                </button>
                <button
                  className={activeTab === "august" ? "active" : ""}
                  onClick={() => setActiveTab("august")}
                >
                  August
                </button>
                <button
                  className={activeTab === "september" ? "active" : ""}
                  onClick={() => setActiveTab("september")}
                >
                  September
                </button>
                <button
                  className={activeTab === "october" ? "active" : ""}
                  onClick={() => setActiveTab("october")}
                >
                  October
                </button>
                <button
                  className={activeTab === "november" ? "active" : ""}
                  onClick={() => setActiveTab("november")}
                >
                  November
                </button>
                <button
                  className={activeTab === "december" ? "active" : ""}
                  onClick={() => setActiveTab("december")}
                >
                  December
                </button>
                <button
                  className={activeTab === "january" ? "active" : ""}
                  onClick={() => setActiveTab("january")}
                >
                  January
                </button>
                <button
                  className={activeTab === "febuary" ? "active" : ""}
                  onClick={() => setActiveTab("febuary")}
                >
                  Febuary
                </button>
              </div>

              <div className="tabs-content">
                {activeTab === "march" &&
                  <div className="tabs-content-wrap">
                    <div className="tabs-content-card">
                      <div className="content-card-img">
                        <img
                          alt=""
                          height="140px"
                          width="100%"
                          src={fileImg}
                        />
                        <button type="button" class="vertical_more_btn" onClick={() => setShowDropdown(!showDropdown)}>
                          <img
                            alt=""
                            height="24px"
                            width="24px"
                            src={moreVertical}
                          />
                        </button>
                        {showDropdown && (
                        <div className="filter_dropdown_box">
                          <button
                            className="filter_dropdown_btn"
                           
                          >
                            <img
                              alt=""
                              width="16px"
                              height="16px"
                              src={editIcon}
                            />
                            Rename
                          </button>
                          <button
                            className="filter_dropdown_btn"
                           
                          >
                            <img
                              alt=""
                              width="16px"
                              height="16px"
                              src={copyIcon}
                            />
                            Copy
                          </button>
                          <button
                            className="filter_dropdown_btn"
                           
                          >
                            <img
                              alt=""
                              width="16px"
                              height="16px"
                              src={downloadBlack}
                            />
                            Download
                          </button>

                          <button
                            className="filter_dropdown_btn delete_btn"
                            
                          >
                            <img
                              alt=""
                              width="16px"
                              height="17px"
                              src={deleteIcon}
                            />
                            Delete
                          </button>
                        </div>
                      )}
                      </div>
                      
                      <div className="content-card-title">
                        <h6>1742979580404_Donald</h6>
                        <div className="tooltip-wrapper">
                        <button type="button" className="tooltip-icon">
                        <img
                          alt=""
                          height="18px"
                          width="18px"
                          src={infoIcon}
                        />
                        </button>
                        <span className="tooltip-text">This is your tooltip info!</span>
                        </div>
                      </div>
                      <div className="downloadBtnWrap">
                        <button type="button" className="downloadBtn">
                          <img src={downloadIcon} alt="logo" /> Download
                        </button>
                      </div>
                    </div>
                    <div className="tabs-content-card">
                      <div className="content-card-img">
                        <img
                          alt=""
                          height="140px"
                          width="100%"
                          src={fileImg}
                        />
                        <button type="button" class="vertical_more_btn">
                          <img
                            alt=""
                            height="24px"
                            width="24px"
                            src={moreVertical}
                          />
                        </button>
                      </div>
                      <div className="content-card-title">
                        <h6>1742979580404_Donald</h6>
                        <img
                          alt=""
                          height="18px"
                          width="18px"
                          src={infoIcon}
                        />
                      </div>
                      <div className="downloadBtnWrap">
                        <button type="button" className="downloadBtn">
                          <img src={downloadIcon} alt="logo" /> Download
                        </button>
                      </div>
                    </div>
                    <div className="tabs-content-card">
                      <div className="content-card-img">
                        <img
                          alt=""
                          height="140px"
                          width="100%"
                          src={fileImg}
                        />
                        <button type="button" class="vertical_more_btn">
                          <img
                            alt=""
                            height="24px"
                            width="24px"
                            src={moreVertical}
                          />
                        </button>
                      </div>
                      <div className="content-card-title">
                        <h6>1742979580404_Donald</h6>
                        <img
                          alt=""
                          height="18px"
                          width="18px"
                          src={infoIcon}
                        />
                      </div>
                      <div className="downloadBtnWrap">
                        <button type="button" className="downloadBtn">
                          <img src={downloadIcon} alt="logo" /> Download
                        </button>
                      </div>
                    </div>
                    <div className="tabs-content-card">
                      <div className="content-card-img">
                        <img
                          alt=""
                          height="140px"
                          width="100%"
                          src={fileImg}
                        />
                        <button type="button" class="vertical_more_btn">
                          <img
                            alt=""
                            height="24px"
                            width="24px"
                            src={moreVertical}
                          />
                        </button>
                      </div>
                      <div className="content-card-title">
                        <h6>1742979580404_Donald</h6>
                        <img
                          alt=""
                          height="18px"
                          width="18px"
                          src={infoIcon}
                        />
                      </div>
                      <div className="downloadBtnWrap">
                        <button type="button" className="downloadBtn">
                          <img src={downloadIcon} alt="logo" /> Download
                        </button>
                      </div>
                    </div>
                    <div className="tabs-content-card">
                      <div className="content-card-img">
                        <img
                          alt=""
                          height="140px"
                          width="100%"
                          src={fileImg}
                        />
                        <button type="button" class="vertical_more_btn">
                          <img
                            alt=""
                            height="24px"
                            width="24px"
                            src={moreVertical}
                          />
                        </button>
                      </div>
                      <div className="content-card-title">
                        <h6>1742979580404_Donald</h6>
                        <img
                          alt=""
                          height="18px"
                          width="18px"
                          src={infoIcon}
                        />
                      </div>
                      <div className="downloadBtnWrap">
                        <button type="button" className="downloadBtn">
                          <img src={downloadIcon} alt="logo" /> Download
                        </button>
                      </div>
                    </div>
                    <div className="tabs-content-card">
                      <div className="content-card-img">
                        <img
                          alt=""
                          height="140px"
                          width="100%"
                          src={fileImg}
                        />
                        <button type="button" class="vertical_more_btn">
                          <img
                            alt=""
                            height="24px"
                            width="24px"
                            src={moreVertical}
                          />
                        </button>
                      </div>
                      <div className="content-card-title">
                        <h6>1742979580404_Donald</h6>
                        <img
                          alt=""
                          height="18px"
                          width="18px"
                          src={infoIcon}
                        />
                      </div>
                      <div className="downloadBtnWrap">
                        <button type="button" className="downloadBtn">
                          <img src={downloadIcon} alt="logo" /> Download
                        </button>
                      </div>
                    </div>
                    <div className="tabs-content-card">
                      <div className="content-card-img">
                        <img
                          alt=""
                          height="140px"
                          width="100%"
                          src={fileImg}
                        />
                        <button type="button" class="vertical_more_btn">
                          <img
                            alt=""
                            height="24px"
                            width="24px"
                            src={moreVertical}
                          />
                        </button>
                      </div>
                      <div className="content-card-title">
                        <h6>1742979580404_Donald</h6>
                        <img
                          alt=""
                          height="18px"
                          width="18px"
                          src={infoIcon}
                        />
                      </div>
                      <div className="downloadBtnWrap">
                        <button type="button" className="downloadBtn">
                          <img src={downloadIcon} alt="logo" /> Download
                        </button>
                      </div>
                    </div>
                  </div>
                }
                {activeTab === "april" && <div>Content of Tab 2</div>}
                {activeTab === "may" && <div>Content of Tab 3</div>}
                {activeTab === "june" && <div>Content of Tab 4</div>}
                {activeTab === "july" && <div>Content of Tab 5</div>}
                {activeTab === "august" && <div>Content of Tab 6</div>}
                {activeTab === "september" && <div>Content of Tab 7</div>}
                {activeTab === "october" && <div>Content of Tab 8</div>}
                {activeTab === "november" && <div>Content of Tab 9</div>}
                {activeTab === "december" && <div>Content of Tab 10</div>}
                {activeTab === "january" && <div>Content of Tab 11</div>}
                {activeTab === "febuary" && <div>Content of Tab 12</div>}
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default Dashboard;
